<template>
    <div class="advertisement">
        <img class="ad-image" src="../../assets/images/start-your-journey.png"/>
    </div>
</template>
<script>
export default {
    
}
</script>
<style scoped>
    .advertisement{
        background-color:var(--guest-background);
        width:100%;
        height:100vh;
        border-bottom-right-radius:24px;
        display: grid;
        grid-template-columns: 1fr 1fr 1fr;
        grid-template-rows: 0.4fr 1fr 1fr;
    }

    .ad-image{
        height: 20rem;
        grid-column:2/3;
        grid-row:2/3;
    }
</style>